import { render, staticRenderFns } from "./softwaremaintenance.vue?vue&type=template&id=389c3982&scoped=true&"
import script from "./softwaremaintenance.vue?vue&type=script&lang=js&"
export * from "./softwaremaintenance.vue?vue&type=script&lang=js&"
import style0 from "./softwaremaintenance.vue?vue&type=style&index=0&id=389c3982&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389c3982",
  null
  
)

export default component.exports